module.exports = __webpack_public_path__ + "images/cm-ext-label.webp";